export default "__VITE_ASSET__e22821c8__"